import { useState, useEffect } from 'react';
import { ArrowDown, ArrowUp } from 'lucide-react';

export default function ScrollButton() {
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Height of the entire document
      const totalHeight = document.documentElement.scrollHeight;
      
      // Height of the visible window
      const visibleHeight = window.innerHeight;
      
      // How much the user has scrolled from the top
      const scrolledFromTop = window.scrollY;

      // Checking if user is near or at the bottom (with a 10px buffer)
      if (scrolledFromTop + visibleHeight >= totalHeight - 10) {
        setIsAtBottom(true);
      } else {
        setIsAtBottom(false);
      }
    };

    // Listen for scroll events
    window.addEventListener('scroll', handleScroll);
    
    // Clean up event listener on unmount
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Handle click action dynamically based on state
  const handleScrollAction = () => {
    if (isAtBottom) {
      // Scroll smoothly to top
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // Scroll smoothly to bottom
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
    }
  };

  return (
    <button
      onClick={handleScrollAction}
      className="text-black duration-300 z-50 transition-all aria-label={isAtBottom ? 'Scroll to top' : 'Scroll to bottom'}"
    >
      {isAtBottom ? (
        <div>
            <ArrowUp stroke-width="1" color='#A0A0A0' className="w-6 h-6 mb-[20px] " />
            <p className='[writing-mode:vertical-lr] '>SCROLL UP</p>
        </div>
      ) : (
        <div>
            <p className='[writing-mode:vertical-lr] mb-[20px] '>SCROLL DOWN</p>
            <ArrowDown stroke-width="1" color='#A0A0A0' className="w-6 h-6 " />
        </div>
        
      )}
    </button>
  );
}
